module.exports = __webpack_public_path__ + "static/img/balance.1f1b2343.png";